var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2875 9.56378L10.5063 14.345C10.3566 14.4947 10.1536 14.5788 9.94184 14.5788C9.73013 14.5788 9.52709 14.4947 9.37739 14.345C9.22769 14.1953 9.14358 13.9923 9.14358 13.7806C9.14358 13.5689 9.22769 13.3658 9.37739 13.2161L12.798 9.79687H3.03625C2.82491 9.79687 2.62222 9.71291 2.47278 9.56347C2.32334 9.41403 2.23938 9.21134 2.23938 8.99999C2.23938 8.78865 2.32334 8.58596 2.47278 8.43652C2.62222 8.28708 2.82491 8.20312 3.03625 8.20312H12.798L9.37872 4.78187C9.22901 4.63217 9.14491 4.42913 9.14491 4.21742C9.14491 4.00571 9.22901 3.80267 9.37872 3.65296C9.52842 3.50326 9.73146 3.41916 9.94317 3.41916C10.1549 3.41916 10.3579 3.50326 10.5076 3.65296L15.2889 8.43421C15.3632 8.50834 15.4221 8.59643 15.4623 8.6934C15.5024 8.79037 15.523 8.89431 15.5229 8.99927C15.5228 9.10423 15.5019 9.20813 15.4615 9.30501C15.4212 9.40189 15.362 9.48983 15.2875 9.56378Z",
    fill: "#F1F1F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.c95ed719d60244f1256c9794b2191ab9.svg";
export { ForwardRef as ReactComponent };